var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMouseClick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_1_x2C___Select_x2C__mouse_pointer_x2C__computer_mouse_x2C__arrow_x2C__mouse_clicker_x2C__mouse_cursor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m485.281 245.312-110.68 60.05 74.72 74.73-69.23 69.23-74.73-74.72-60.05 110.68-102.07-342.01.02-.01z",
    fill: "#4da6ff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m511.219 242.616s0 0-.003-.001h-.001c-.007-.002-.01-.003-.009-.003-.445-.133-14.893-4.443-371.044-110.693l-8.141 8.722 110.594 370.578 65.149-120.076 72.325 72.327 83.378-83.378-72.327-72.325zm-76.036 137.475-55.093 55.093-77.128-77.128-54.956 101.289-89.895-301.219 301.23 89.882-101.287 54.955z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.229 35.729h20.001v83.004h-20.001z",
    transform: "matrix(.707 -.707 .707 .707 -31.99 77.23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.781 151.6h83.003v20h-83.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.728 235.969h83.004v20.001h-83.004z",
    transform: "matrix(.707 -.707 .707 .707 -151.307 126.652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.467 67.23h83.004v20.001h-83.004z",
    transform: "matrix(.707 -.707 .707 .707 17.432 196.546)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.599.782h20v83.003h-20z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseClick);
export default __webpack_public_path__ + "static/media/mouse_click.7f3b8adb482c561eb6ed9e9b2f51d59e.svg";
export { ForwardRef as ReactComponent };